import rateComment from "@/components/features/rate-comment/index.vue";
import {mapActions, mapMutations} from "vuex";

export default {
    name: "LessonRateComment",
    components: {
        rateComment,
    },
    props: {
        lesson: {
            required: true,
            type: Object,
        },
        focusInput: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            progress: false,
            comment: "",
            inEdit: false
        };
    },
    computed: {
        hasCreatedRateMessage() {
            return Boolean(
                !Array.isArray(this.lesson.userRating.data) &&
                this.lesson.userRating.data.comment
            );
        },
        storedComment() {
            return this.lesson.userRating.data.comment;
        },
    },
    mounted() {
        this.comment = this.storedComment;
    },
    watch: {
        'lesson.userRating.data'(rate) {
            if (rate.rating) {
                this.inEdit = true;
            }
        },
    },
    methods: {
        ...mapMutations({
            setLessonRate: "coursesLesson/SET_LESSON_RATE",
        }),
        ...mapActions({
            updateLessonRateComment: "coursesLesson/UPDATE_LESSON_RATE_COMMENT",
        }),
        async onSubmit(comment) {
            try {
                this.progress = true;
                await this.updateLessonRateComment({
                    item: this.$route.params.item,
                    moduleSlug: this.$route.params.moduleSlug,
                    slug: this.lesson.slug,
                    rateId: this.lesson.userRating.data.id,
                    comment,
                });
                this.inEdit = false;
            } catch (e) {
                // TODO: show toast
                console.error(e.message);
            } finally {
                this.progress = false;
            }
        },
        onCancel() {
            this.inEdit = false;
            this.comment = this.storedComment;
        },
        onNeedEdit() {
            this.inEdit = true;
        }
    },
};
